import { Component, OnInit, Inject } from '@angular/core';
import { listPagesDB } from 'src/app/shared/tables/list-pages';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-list-page',
  templateUrl: './list-page.component.html',
  styleUrls: ['./list-page.component.scss']
})
export class ListPageComponent implements OnInit {
  public list_pages = [];

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }


  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/pages/').subscribe(
        data => {
          this.list_pages = data.data;
          // console.log(this.blogs);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

}
